import { EPaymentInitSource } from '../../types/redux/checkout';
import { loadPaymentMethodsThunk } from '../loadPaymentMethods';
import { setLayoutState, setWidgetStatus, setWidgetVisibility } from '../../actions/layout';
import { EWidgetMode, EWidgetStatus } from '../../types/redux/layout';
import { TThunkAction } from '../../types/redux';
import { trackPaymentWidgetShow } from '../../trackers';
import { setDepositCheckoutState } from '../../actions/checkout';

interface IParams {
  amount: number;
  paymentInitSource: EPaymentInitSource;
  isModal: boolean;
  transactionId: string | undefined;
}

export const launchDepositWidgetThunk =
  (params: IParams): TThunkAction =>
  async dispatch => {
    const { amount, paymentInitSource, isModal, transactionId } = params;

    const mode = EWidgetMode.Deposit;

    dispatch(setLayoutState({ mode, isModal }));
    dispatch(setWidgetVisibility(true));

    await dispatch(loadPaymentMethodsThunk({ paymentInitSource }));

    dispatch(setDepositCheckoutState({ paymentAmount: amount, paymentInitSource, transactionId }));
    dispatch(setWidgetStatus(EWidgetStatus.Ready));

    trackPaymentWidgetShow({ paymentInitSource, mode });
  };
